import { CommonStylesDefaultValues } from 'cms/cms-shared/common-settings-styles/common-settings-styles.models';
import { IdtComponentCmsDefinition, CmsComponentGroups } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';

import { PieceFragmentSettings } from './models/piece-fragment.models';


export const PieceFragmentDefinition: IdtComponentDefinition = {
  id: 'piece-fragment',
  role: IdtComponentRole.Piece,
  numSlots: 0
};

export const PieceFragmentCmsDefinition: IdtComponentCmsDefinition = {
  ...PieceFragmentDefinition,
  name: 'Contenido Reutilizable',
  group: CmsComponentGroups.Fragments,
  availablePlatforms: ['web', 'apps'],
  initialSettings: (): PieceFragmentSettings => {
    return {
      general: {
        slug: null,
        name: null
      },
      styles: CommonStylesDefaultValues
    };
  }
};
